import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {List, Map} from 'immutable';
import PieChart from 'generic/PieChart/PieChart.react';

const colorMap = new Map({
  Mastery: '#985bcd',
  Excelling: '#2DADFF',
  Proficient: '#88d371',
  Passing: '#f0bf6c',
  Struggling: '#dd5566',
  'N/A': '#979ea1'
});

export default class MasteryChart extends React.Component {
  static propTypes = {
    statuses: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
    showKey: PropTypes.bool,
    showLabels: PropTypes.bool,
    size: PropTypes.number,
    lineWidth: PropTypes.number,
    showNAStatus: PropTypes.bool
  };

  createLegendListItems(pieChartData) {
    return pieChartData.map((datum, i) => {
      const statusName = datum.get('title');
      const statusCount = datum.get('value');
      if (statusName === 'N/A' && !this.props.showNAStatus) {
        return null;
      }
      return (
        <li className='accuracy-chart__legend-item' key={i}>
          <div
            className='accuracy-chart__legend-item-color'
            style={{backgroundColor: datum.get('color')}}
          />
          {statusName}: <strong className='accuracy-chart__legend-item-count'>{statusCount}</strong>
        </li>
      );
    });
  }

  makeMasteryBuckets() {
    // Translates our static status to color mapping into BUCKETS we can PUT THINGS INTO
    return colorMap.map((item, key) => {
      // returning a map instead of a single value to potentially leave this open to expansion
      return new Map({
        value: 0
      });
    });
  }

  render() {
    /*
       Here we reduce our accuracies into our bucket map,
       increasing the count for each mastery level as we loop through our accuracies

       leaves us with a list something like
          ['Excelling': {
            value: x
          }, ...]
       etc, for each status.
    */
    const masteryCounts = this.props.statuses.reduce((reduction, status) => {
      // increase the count of the thing in our bucket
      const countPath = [status, 'value'];
      const currentCount = reduction.getIn(countPath);
      return reduction.setIn(countPath, currentCount + 1);
    }, this.makeMasteryBuckets());

    /*
      Flatten our buckets into a list that our chart can consume,
      and that we can use to render our key with

      leaves us with:
        [{
          title: 'Excelling',
          value: x,
          color: #2DADFF
        }, ...]
      for each status
    */
    const pieChartData = masteryCounts.reduce((reduction, masteryBucket, bucketStatusKey) => {
      return reduction.push(
        new Map({
          title: bucketStatusKey,
          value: masteryBucket.get('value'),
          color: colorMap.get(bucketStatusKey) // grab our color based on status
        })
      );
    }, new List());

    const key = !this.props.showKey ? null : (
      <ul className='accuracy-chart__legend'>{this.createLegendListItems(pieChartData)}</ul>
    );
    return (
      <div className='accuracy-chart'>
        <PieChart
          data={pieChartData}
          size={this.props.size}
          lineWidth={this.props.lineWidth}
          showLabels={this.props.showLabels}
        />
        {key}
      </div>
    );
  }
}
